export default {
  isLoading: state => state.loading,
  isReady: state => state.ready,
  isError: state => state.error,
  data: (state, getters, rootState) => rootState.auth?.authUserData?.courses,
  table: state => state.table
}
